var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import FSSwitch from '@components/FSSwitch';
import { useVersionsActions } from '@data/hooks/versions';
import { Plus } from '@shared/icons/icons';
import Modal from '@shared/modal/Modal';
import ModalHeader from '@shared/modal/ModalHeader';
import { Confirmation } from '@shared/modal/Simple';
import { ModalBody } from '@styled/Modal';
import React, { useRef, useState } from 'react';
import FormInput from '../../../shared/forms/FormInput';
import Manager from '../../../shared/modal/Manager';
import ModalFooter from '../../../shared/modal/ModalFooter';
function VersionItem(props) {
    var data = props.data, deleteVersion = props.deleteVersion, updateVersion = props.updateVersion;
    var name = data.name, active = data.active;
    var _a = __read(useState(name), 2), nameValue = _a[0], setNameValue = _a[1];
    var nameRef = useRef(null);
    var L = useLanguage().L;
    function changeHandler(e) {
        setNameValue(e.target.value);
    }
    function enterPressHandler(e) {
        var _a;
        if (e.key === 'Enter') {
            //updateVersion({ ...data, name: e.currentTarget.value });
            (_a = nameRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }
    function blurHandler(e) {
        if (e.target.value === '') {
            setNameValue(name);
        }
        updateVersion(__assign(__assign({}, data), { name: e.target.value }));
    }
    function toggleHandler() {
        updateVersion(__assign(__assign({}, data), { active: !active }));
    }
    function deleteHandler() {
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L('Confirm delete operation')), onOk: function () {
                deleteVersion(data);
            } },
            React.createElement("span", null,
                L('Are you sure you want to delete'),
                " ",
                React.createElement("b", null, name),
                ' ' + L('variation'),
                "?")));
    }
    var addedBy = 'Default';
    return (React.createElement("li", { className: "version-item" },
        React.createElement("div", { className: "version-name version-value" },
            React.createElement("input", { ref: nameRef, type: "text", value: nameValue, onChange: changeHandler, onBlur: blurHandler, onKeyPress: enterPressHandler })),
        React.createElement("div", { className: "version-added version-value" },
            React.createElement("p", null, addedBy)),
        React.createElement("div", { className: "version-options" },
            React.createElement("div", { className: "options-container" },
                React.createElement(FSSwitch, { checked: active, onChange: toggleHandler }),
                React.createElement(FSButton, { "$type": "tertiary", "$color": "error", title: L('Delete'), onClick: deleteHandler })))));
}
function Versions(props) {
    var L = useLanguage().L;
    var _a = useVersionsActions(), deleteVersion = _a.deleteVersion, updateVersion = _a.updateVersion;
    var versions = props.versions;
    function addVersionHandler() {
        Manager.renderModal(React.createElement(AddVersionModal, { versions: versions }));
    }
    var versionItems = versions.map(function (version) { return (React.createElement(VersionItem, { key: version.id, data: version, deleteVersion: deleteVersion, updateVersion: updateVersion })); });
    return (React.createElement("div", { className: "versions-container" },
        React.createElement("div", { className: "versions-header" },
            React.createElement("h4", { className: "versions-title" }, L('Versions')),
            React.createElement(FSButton, { title: L('Add Version'), icon: Plus, className: "header-button", onClick: addVersionHandler })),
        React.createElement("div", { className: "versions-content" },
            React.createElement("div", { className: "versions-columns" },
                React.createElement("div", { className: "version-name columns-item" },
                    React.createElement("h5", null, L('Name & Color'))),
                React.createElement("div", { className: "version-added columns-item" },
                    React.createElement("h5", null, L('Added By'))),
                React.createElement("div", { className: "version-options columns-item" },
                    React.createElement("h5", null, L('Options')))),
            React.createElement("div", { className: "list-wrapper" },
                React.createElement("ul", { className: "versions-list" }, versionItems)))));
}
var AddVersionModal = function (props) {
    var versions = props.versions;
    var addVersion = useVersionsActions().addVersion;
    var L = useLanguage().L;
    var _a = __read(useState({}), 2), invalid = _a[0], setInvalid = _a[1];
    var _b = __read(useState(''), 2), value = _b[0], setValue = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    function validate() {
        var inv = {};
        if (value === null || value === '') {
            inv.var = 'You must enter a name.';
        }
        if (versions.some(function (_a) {
            var name = _a.name;
            return name === value;
        })) {
            if (value !== value) {
                inv.var = 'This version name is already taken.';
            }
        }
        return inv;
    }
    function save(e) {
        return __awaiter(this, void 0, void 0, function () {
            var _invalid, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        _invalid = validate();
                        if (!(Object.keys(_invalid).length === 0)) return [3 /*break*/, 6];
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, addVersion(value)];
                    case 2:
                        _a.sent();
                        Manager.closeModal();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        setInvalid({ var: error_1.message ? error_1.message : L('Error adding version.') });
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        setInvalid(_invalid);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    var title = "".concat(L('Add new version'));
    return (React.createElement(Modal, { width: "400", height: "300" },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", { className: "form-horizontal spacer-15", onSubmit: save },
                React.createElement(FormInput, { label: L('New version name'), onChange: function (e) {
                        setValue(e.target.value);
                    }, error: invalid.var, value: value }))),
        React.createElement(ModalFooter, { loading: loading, done: save })));
};
export default Versions;
